import React, { useEffect, useRef, useState } from 'react';
import { loadGoogleMaps } from '../../lib/googleMaps';

export default function BusinessMap({ business }) {
  const mapRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function drawMap() {
      try {
        const maps = await loadGoogleMaps();
        await maps.importLibrary('maps');
        if (!active || !mapRef.current) return;

        const center = {
          lat: business.location.lat(),
          lng: business.location.lng()
        };
        const map = new maps.Map(mapRef.current, {
          center,
          zoom: 15,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false
        });
        new maps.Marker({ map, position: center, title: business.name });
      } catch {
        if (active) setError('The map could not be displayed.');
      }
    }

    drawMap();
    return () => {
      active = false;
    };
  }, [business]);

  if (error) return <p role="alert" className="p-6 text-sm text-slate-300">{error}</p>;
  return <div ref={mapRef} aria-label={`Map showing ${business.name}`} className="h-64 w-full sm:h-80" />;
}